import Page from 'components/layout/Page';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import Script from 'next/script';
import { APP_URLS } from 'utils/app-urls';
import ContactForm from './form/ContactForm';

export const ContactPage: React.FC = () => {
  const { t } = useI18n('contact');

  return (
    <Page hasScrollTop>
      <HeadMetadata
        title={t('contact.page_title')}
        url={APP_URLS.contact}
        desc={t('contact.page_description')}
        indexable={true}
      />
      <Script
        id="contactLD"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
        {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "url": "https://www.getmanfred.com/contacto",
  "name": "${t('contact.page_title')}",
  "description": "${t('contact.page_description')}",
  "publisher": {
    "@type": "Organization",
    "name": "Manfred",
    "url": "https://www.getmanfred.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg",
      "width": 200,
      "height": 50
    },
    "sameAs": [
      "https://twitter.com/getmanfred",
      "https://www.linkedin.com/company/getmanfred",
      "https://www.getmanfred.com"
    ]
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "support@getmanfred.com",
    "availableLanguage": ["Spanish", "English"],
    "areaServed": "Worldwide"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ]
  }
}`
        }}
      />
      <ContactForm />
    </Page>
  );
};
